export const SELECT_BILL_DATE = 'SELECT_BILL_DATE';
export const CLEAR_BILL_DATE = 'CLEAR_BILL_DATE';

export default (selectedBillDate, adjustmentDays) => ({
  type: SELECT_BILL_DATE,
  payload: {
    selectedBillDate,
    adjustmentDays,
  },
});

export const clearBillDate = () => ({
  type: CLEAR_BILL_DATE,
});
